var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 32,
    viewBox: "0 0 57 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "social icon for Medium") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7881 16C31.7881 24.83 24.6887 32 15.894 32C7.09934 32 0 24.83 0 16C0 7.16998 7.09934 0 15.894 0C24.6887 0 31.7881 7.16998 31.7881 16ZM49.2009 16C49.2009 24.3002 45.6336 31.0464 41.2539 31.0464C36.8742 31.0464 33.3069 24.3002 33.3069 16C33.3069 7.69978 36.8742 0.953636 41.2539 0.953636C45.6336 0.953636 49.2009 7.66446 49.2009 16ZM56.3356 16C56.3356 23.4525 55.0994 29.4923 53.5453 29.4923C51.9912 29.4923 50.755 23.4525 50.755 16C50.755 8.54746 51.9912 2.50772 53.5453 2.50772C55.0994 2.50772 56.3356 8.54746 56.3356 16Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.7687263007fffc7045631337d7d1d427.svg";
export { ForwardRef as ReactComponent };